import type { FeedChannel, FeedStatus } from '@nucleus-commerce/api-client/admin';

export type FeedStatusKey = keyof FeedStatus;

/** Page order; the path segment of each channel and its key in the status response. */
export const FEED_CHANNELS: ReadonlyArray<{ channel: FeedChannel; key: FeedStatusKey }> = [
  { channel: 'google-merchant', key: 'googleMerchant' },
  { channel: 'meta-catalog', key: 'metaCatalog' },
  { channel: 'pinterest', key: 'pinterest' },
];

export function statusKeyOf(channel: FeedChannel): FeedStatusKey {
  const found = FEED_CHANNELS.find((c) => c.channel === channel);
  if (!found) throw new Error(`Unknown feed channel ${channel}`);
  return found.key;
}
